// Konvertera hex till "H S% L%" för CSS-variabler (tailwind hsl(var(--x)))
export function hexToHslVar(hex) {
  if (!hex) return null;
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let hue = 0, s = 0; const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) hue = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) hue = (b - r) / d + 2;
    else hue = (r - g) / d + 4;
    hue /= 6;
  }
  return `${Math.round(hue * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export function applyBrandColors(primary, accent) {
  const root = document.documentElement;
  const p = hexToHslVar(primary);
  const a = hexToHslVar(accent);
  if (p) root.style.setProperty("--primary", p);
  if (a) { root.style.setProperty("--accent", a); root.style.setProperty("--ring", a); }
  if (!primary) root.style.removeProperty("--primary");
  if (!accent) { root.style.removeProperty("--accent"); root.style.removeProperty("--ring"); }
}

// Läs en fil som base64 data-URL (för logotyp)
export function fileToDataUrl(file, maxBytes = 500000) {
  return new Promise((resolve, reject) => {
    if (file.size > maxBytes) return reject(new Error("Filen är för stor (max 500 KB)."));
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
